export default __webpack_public_path__ + "static/media/credit-card.a190096f.svg";